import { sleep } from '@js/helpers/utils';
import whenDomReady from 'when-dom-ready';
let hasAnimatedTools = false;
whenDomReady().then(() => {
    bindScrollEvent();
});
function bindScrollEvent() {
    window.addEventListener('scroll', e => {
        console.log(`Inner height: ${window.innerHeight}, Scroll: ${window.scrollY}, body height: ${document.body.offsetHeight}`);
        //AB - Added Math.ceil to fix issue with innerHeight and scrollY not being whole numbers so the sum is slightly lower than it needs to be
        const scroll = Math.ceil(window.innerHeight + window.scrollY);
        if (scroll >= document.body.offsetHeight - 5 && scroll <= document.body.offsetHeight + 5) {
            // We're at the bottom of the page
            handleHitBottom();
        }
        else {
            // Else we reset the footer
            reset();
        }
    });
}
/**
 * Handles hitting the bottom of the page on scroll.
 */
async function handleHitBottom() {
    const footer = document.querySelector('footer');
    if (!footer) {
        return;
    }
    // Set this to 0 to animate in
    footer.style.marginBottom = '0px';
    // wait for the animation to finish
    await sleep(200);
    // Then animate the tools
    animateTools();
}
/**
 * Resets the footer styling (to be used when no longer at the bottom of the page)
 */
function reset() {
    const footer = document.querySelector('footer');
    if (!footer) {
        return;
    }
    // Clear the styles to reset
    footer.style.marginBottom = '';
}
/**
 * Animates the wheelbarrow, trowel and fork into the page. This will only happen once.
 */
function animateTools() {
    if (hasAnimatedTools === true) {
        return;
    }
    const footer = document.querySelector('footer');
    const wheelBarrow = document.querySelector('.wheelbarrow');
    const trowel = document.querySelector('.trowel');
    const fork = document.querySelector('.fork');
    if (!footer || !wheelBarrow || !trowel || !fork) {
        return;
    }
    // Make sure we don't re-animate
    hasAnimatedTools = true;
    // Now calculate the new positions and animate
    const height = footer.getBoundingClientRect().height;
    // Barrow
    wheelBarrow.style.left = '0px';
    wheelBarrow.style.bottom = `${height}px`;
    wheelBarrow.style.opacity = '1';
    wheelBarrow.style.animationPlayState = 'running';
    // Trowel
    trowel.style.right = '189px';
    trowel.style.bottom = `${height}px`;
    trowel.style.animationPlayState = 'running';
    // Fork
    fork.style.right = '20px';
    fork.style.bottom = `${height}px`;
    fork.style.animationPlayState = 'running';
}
